module.exports = __webpack_public_path__ + "media/images/emblems/Demoret-coat_of_arms-29405347201503f237440970486c69a8.svg";